import { SIM9_COURSES } from './courses';
import { themeById, type Putt3dTheme } from './themes';
import type { RealisticSceneryId } from './realistic';

export interface StockScenery {
  sceneryId: RealisticSceneryId;
  theme: Putt3dTheme;
}

/** Environment only: never copies a course's distances, par or scoring rules. */
export function pickStockScenery(random: () => number = Math.random): StockScenery {
  const draw = random();
  const unit = Number.isFinite(draw) ? Math.max(0, Math.min(1 - Number.EPSILON, draw)) : 0;
  const course = SIM9_COURSES[Math.floor(unit * SIM9_COURSES.length)];
  return { sceneryId: course.sceneryId!, theme: themeById(course.themeId) };
}

/** One lazy selection per mode session. The mode owner retains this picker
 * across holes, players, stage remounts, replays and display/quality changes. */
export function createStockSceneryPicker(random: () => number = Math.random): () => StockScenery {
  let selection: StockScenery | undefined;
  return () => selection ?? (selection = pickStockScenery(random));
}
